export default __webpack_public_path__ + "images/0618ada736f59249b6e435356647eb4c.svg";